module.exports = __webpack_public_path__ + "img/20231101110142931zlv.823c800c.png";